export const ITEMS_PER_PAGE = 10;

export const INITIAL_WAREHOUSE_STATE = {
  uuid: null,
  code: '',
  name: '',
  uuid_branch: '',
  address: '',
  is_active: true,
};

export const VALIDATION_RULES = {
  CODE_MAX_LENGTH: 50,
  NAME_MAX_LENGTH: 150,
  ADDRESS_MAX_LENGTH: 255,
};

export const MESSAGES = {
  ERROR: {
    REQUIRED_FIELD: 'Este campo es obligatorio',
    CODE_MAX_LENGTH: `Máximo ${VALIDATION_RULES.CODE_MAX_LENGTH} caracteres`,
    NAME_MAX_LENGTH: `Máximo ${VALIDATION_RULES.NAME_MAX_LENGTH} caracteres`,
    ADDRESS_MAX_LENGTH: `Máximo ${VALIDATION_RULES.ADDRESS_MAX_LENGTH} caracteres`,
  },
};

/** Opciones de estado del formulario de edición de depósito. */
export const WAREHOUSE_STATUS_OPTIONS = [
  { value: true, label: 'Activo' },
  { value: false, label: 'Inactivo' },
];

export const WAREHOUSES_TABLE_TEXTS = {
  code: 'Código',
  name: 'Nombre',
  branch: 'Sucursal',
  address: 'Dirección',
  actions: 'Acciones',
  edit: 'Editar',
  delete: 'Eliminar',
  empty: 'No se encontraron depósitos',
};

export const WAREHOUSE_FORM_TEXTS = {
  createTitle: 'Nuevo depósito',
  editTitle: 'Editar depósito',
  code: 'Código',
  name: 'Nombre',
  branch: 'Sucursal',
  branchPlaceholder: 'Buscar sucursal',
  noBranch: 'Sin sucursal',
  address: 'Dirección',
  status: 'Estado',
  create: 'Crear',
  update: 'Actualizar',
};
